import type { ProgramCenteredListResponse } from "@solomon-apps/shared";
import { useQuery } from "@tanstack/react-query";

import { fetchClientFundingSources } from "@/services/clientFundingSources";
import type { ClientFundingSource } from "@/types/programCenteredYaas";

import { useClientContextKey } from "./useClientContextKey";

export const CLIENT_FUNDING_SOURCES_QUERY_KEY = ["yaas-client", "funding-sources"] as const;

/**
 * Read-only: a client cannot create a Funding Source or attach one to a
 * Program. Both writes are Jachin's now -- see `clientFundingSources.ts` for
 * how the address is provisioned.
 */
export function useClientFundingSources(): {
    data: ProgramCenteredListResponse<ClientFundingSource> | undefined;
    fundingSources: ClientFundingSource[];
    isLoading: boolean;
    error: Error | null;
} {
    const contextKey = useClientContextKey();
    const { data, isLoading, error } = useQuery<ProgramCenteredListResponse<ClientFundingSource>, Error>({
        queryKey: [...CLIENT_FUNDING_SOURCES_QUERY_KEY, contextKey],
        queryFn: fetchClientFundingSources,
        staleTime: 2 * 60 * 1000
    });

    return {
        data,
        fundingSources: data?.data ?? [],
        isLoading,
        error
    };
}
